import { render, staticRenderFns } from "./UploaderWithBgPosition.vue?vue&type=template&id=536819d1&scoped=true&"
import script from "./UploaderWithBgPosition.vue?vue&type=script&lang=js&"
export * from "./UploaderWithBgPosition.vue?vue&type=script&lang=js&"
import style0 from "./UploaderWithBgPosition.vue?vue&type=style&index=0&id=536819d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536819d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VSlider})
